import { useEffect, useMemo } from 'react';

import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { progressBarsDesigns } from 'components/TemplatesStudio/DesignsMetadata/progressBars.metadata';

import { DesignSidebarItem } from '../Components/DesignSidebarItem';

export const ProgressBarsSecondarySidebar: React.FC = () => {
  const { setDisplayProgressBarPreview } = useTemplateStudioState();

  useEffect(() => {
    setDisplayProgressBarPreview(true);
    return () => {
      setDisplayProgressBarPreview(false);
    };
  }, []);

  const designs = useMemo(() => {
    return Object.values(progressBarsDesigns);
  }, []);

  return (
    <>
      {designs.map((design) => (
        <DesignSidebarItem
          key={design.id}
          {...design}
          blockDesignIdPath="progressBar.selectedDesignId"
        />
      ))}
    </>
  );
};
